import capitalizeWords from './capitalizeWords';

export default function getFormattedUsernameAndInitials(username) {
  let formattedUsername = {
    name: `${username}`.trim(),
    initials: ''
  };
  if(!!formattedUsername.name.length && formattedUsername.name.includes(' ')) {
    const usernames = capitalizeWords(formattedUsername.name).split(' ');
    formattedUsername = {
      name: `${usernames[0]} ${usernames[1].charAt(0)}.`,
      initials: `${usernames[0].charAt(0)}${usernames[1].charAt(0)}`
    };
  }
  return formattedUsername;
}
